module.exports = {
  "language": "Язык",
  "actors": "Актеры",
  "ID": "Я БЫ",
  "search": "Поиск",
  "copied": "Скопировано в буфер обмена",
  "sort": "Sort {0}",
  "yes": "Да",
  "no": "Нет",
  "notifications": {
    "title": "Уведомления",
    "empty": "У вас нет уведомлений"
  },
  "auth": {
    "logout": "Выйти",
    "login": "Авторизоваться",
    "register": "Зарегистрировать новую учетную запись"
  },
  "user": {
    "changePassword": "Изменить пароль",
    "firstPasswordChange": "Вы должны изменить свой пароль при первом входе в систему",
    "plural": "Пользователи",
    "single": "Пользователь",
    "filters": {
      "locked": "Показать заблокированных пользователей"
    },
    "fields": {
      "password": "Пароль",
      "authorizations": "Разрешения",
      "email": "Эл. адрес",
      "name": "Имя",
      "repeatPassword": "Повторите пароль"
    },
    "validation": {
      "length": "8 символов длиной",
      "uppercase": "Буква в верхнем регистре",
      "lowercase": "Одна строчная буква",
      "number": "Один номер",
      "special": "Один специальный символ (!@#$%^&*_ =+-)"
    }
  },
  "contact": {
    "fields": {
      "phone": "Телефон",
      "company": "Название компании",
      "street": "Улица",
      "zipCode": "Почтовый индекс",
      "city": "Город",
      "country": "Страна",
      "houseNumber": "номер дома"
    }
  },
  "errors": {
    "loginWrong": " tente novamente!\"",
    "notFound": {
      "title": "Страница не найдена",
      "message": "Уп! Эта страница не была найдена."
    },
    "noInternet": " aktualizacja będzie nieskrępowana automatycznie\""
  },
  "messages": {
    "sureDelete": "¿Estás seguro de que quieres eliminar {0}?",
    "sureSave": "¿Estás seguro de que quieres guardar {0}?"
  },
  "tradelane": {
    "fields": {
      "sender": "Отправитель",
      "receiver": "Получатель"
    }
  },
  "ecmr": {
    "single": "e-CMR",
    "fields": {
      "license": "Номерной знак"
    }
  },
  "company": {
    "single": "Компания"
  },
  "scan": {
    "currentStage": "Текущий этап",
    "description": "Описание",
    "qrCode": "QR код",
    "locationNotAccessible": "Местоположение не найдено",
    "noEmballage": "Нет упаковки",
    "noMessage": "Не добавлено сообщения",
    "missingCargo": "Отсутствует груз",
    "shipmentAndBarcodes": "Отгрузка и штрих -коды",
    "scanPackages": "Сканировать пакеты",
    "emballage": "Пояснить",
    "required": "Необходимый",
    "upload": "Загрузить",
    "statusRequirements": "Требования к статусу",
    "addPhoto": "Добавить фото",
    "addAttachments": "Добавить вложения",
    "addMessage": "Добавить сообщение",
    "addEmballage": "Добавить Emballage",
    "signOnGlass": "Подписать стекло",
    "start": "Начинать",
    "shelvesExtensions": "Полки и расширения",
    "notready": "Не готов",
    "manco": "Отсутствующий",
    "fields": {
      "message": "Сообщение",
      "attach": "Соединять",
      "detach": "Отключить"
    },
    "changeAmounts": "Изменить суммы",
    "damage": "Наносить ущерб",
    "not": "Нет",
    "mancoMessage": "\"Не могли бы отсканировать штрих -код или пакет"
  },
  "sign": {
    "sign": "Знак",
    "signAbsence": "Подписано в отсутствие клиента"
  },
  "erp": {
    "single": "Эрп",
    "packaging": "Упаковка"
  },
  "nav": {
    "finished": "Законченный",
    "current": "Текущий",
    "overview": "Обзор",
    "messages": "Сообщения",
    "shipment": "Отправка",
    "shipments": "Поставки",
    "settings": "Настройки",
    "planning": "ЖЕЛЛИСТ",
    "report": "Отчеты"
  },
  "wallet": {
    "single": "Бумажник"
  },
  "common": {
    "info": "Информация",
    "status": "Статус",
    "location": "Расположение",
    "contact": "Контакт",
    "contacts": "Контакты",
    "photos": "Фото",
    "attachments": "Вложения",
    "identifier": "Идентификатор",
    "type": "Тип",
    "actions": "Действия",
    "name": "Имя",
    "value": "Ценность",
    "tradelane": "Трагилан",
    "date": "Свидание",
    "actor": "Актер",
    "create": "Создавать",
    "from": "Из",
    "to": "К",
    "general": "Общий",
    "back": "Назад",
    "next": "Следующий",
    "finish": "Заканчивать",
    "clear": "чистый",
    "notes": "Заметки",
    "details": "Подробности",
    "retry": "Повторно",
    "amount": "Количество",
    "trip": "Путешествие",
    "references": "использованная литература",
    "in": "В",
    "out": "Вне",
    "senderMessage": "Отмещение отправителя",
    "receiverMessage": "Замечание приемника",
    "total": "Общий"
  },
  "actions": {
    "shipmentCreated": "Отгрузка создана",
    "shipmentUpdated": "Отгрузка обновлена",
    "planningCreated": "Планирование создано",
    "planningUpdated": "Планирование обновлено",
    "accesscodeCreated": "Код доступа создан",
    "accesscodeShared": "Код доступа общий",
    "notificationSent": "Уведомление отправлено",
    "partOfAccesscodeCreated": "Элемент созданного кода доступа для планирования",
    "partOfAccesscodeShared": "Элемент общего кода доступа для планирования",
    "addObj": "Добавить {0}",
    "add": "Добавлять",
    "save": "Сохранять",
    "saveObj": "Сохранить {0}",
    "copy": "Копия",
    "send": "Отправлять",
    "continue": "Продолжать",
    "close": "Закрывать"
  },
  "shipment": {
    "eta": "ETA",
    "ata": "Ата",
    "single": "Отправка",
    "status": "Статус",
    "finished": "Дополнительные поставки",
    "pickup": "Подбирать",
    "delivery": "Доставка",
    "delivered": "Доставка",
    "pickedUp": "Доставленный",
    "fields": {
      "parties": "Стороны",
      "createdAt": "Создано на",
      "updatedAt": "Обновлено в"
    },
    "consignment": {
      "single": "Партия",
      "scanned": {
        "waiting": "{Id} salva! \\ NSTORATING dados podem levar algum tempo."
      }
    },
    "containers": {
      "fields": {
        "hsCode": "HS -код",
        "packQuantity": "Количество упаковки",
        "packSize": "Размер упаковки",
        "weight": "Масса"
      }
    },
    "info": {
      "fields": {
        "hazardous": "Содержит опасные товары"
      }
    },
    "documents": {
      "fields": {
        "file": "Файл"
      }
    },
    "selectTradelane": {
      "fields": {
        "freightPrice": "Прайс грузовых перевозок"
      }
    },
    "lastStatus": "Последний статус"
  },
  "accept": {
    "updateShipment": "Обновить отгрузку",
    "zeroEmballageMessage": "Você não especificou nenhuma embalagem. Especifique um motivo abaixo ou clique em Concluir."
  },
  "apiKeys": {
    "plural": "Ключи API",
    "single": "API -ключ",
    "fields": {
      "key": "Ключ"
    }
  },
  "planning": {
    "driverInformation": "Информация о драйвере"
  },
  "from": "Из",
  "for": "За",
  "commissioned_by": "Показывается",
  "planning_finished": "Планирование закончено",
  "sure_question": "Ты уверен?",
  "sure_question_cancel": "Вы отменяете активную остановку. Уверены ли вы?"
}